import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Background from "./components/Background";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";
import styles from "./style.module.scss";

const Layout = (props) => {
  let navigate = useNavigate();
  const { navType } = props;
  const { t } = useTranslation();

  const renderHeader = () => {
    if (navType.hideHeader) {
      return null;
    }
    return <Navigation {...navType} />;
  };

  const renderFooter = () => {
    if (navType.hideFooter) {
      return null;
    }
    return <Footer />;
  };

  return (
    <Background>
      <div className={styles.main}>
        {renderHeader()}
        <div className={styles.container}>{props.children}</div>
        {renderFooter()}
      </div>
    </Background>
  );
};
export default Layout;
